'use strict';

/**
* Saves the state of a refinement (expanded or collapsed) in the session storage.
* 
* @param {string} refinementID - The unique identifier for the refinement.
* @param {boolean} isExpanded - The state of the refinement, where true indicates expanded and false indicates collapsed.
* @returns {void}
*/
function saveRefinementState(refinementID, isExpanded) {
    const refinementState = JSON.parse(sessionStorage.getItem('refinementState')) || {};
    refinementState[refinementID] = isExpanded;
    sessionStorage.setItem('refinementState', JSON.stringify(refinementState));
}

/**
* Retrieves the state of a specific refinement based on its ID from the session storage.
* 
* @param {string} refinementID - The unique identifier for the refinement.
* @returns {boolean} - The state of the specified refinement, or false if not found.
*/
function getRefinementState(refinementID) {
    const refinementState = JSON.parse(sessionStorage.getItem('refinementState')) || {};
    return refinementState[refinementID] || false;
}

/**
* Initializes the state of a refinement item in the search refine bar.
* 
* @param {jQuery} item - The jQuery object representing the refinement item.
*/
function initRefinementsState(item) {
    if (!item.hasClass('default-active')) {
        const refinementID = item.data('target').replace('#refinement-', '');
        const isExpanded = getRefinementState(refinementID);

        item.attr('aria-expanded', isExpanded);

        if (!item.hasClass('pointArrow') && isExpanded) {
            item.addClass('pointArrow');
        }

        const $collapseElement = $('#refinement-' + refinementID);
        const $collapseElementWrapper = $collapseElement.closest('.card');

        if ($collapseElement.length) {
            $collapseElement.toggleClass('show', isExpanded);
            $collapseElementWrapper.toggleClass('active', isExpanded);
        }
    }
}

module.exports = function () {
    const $refinementButtons = $('.js-custom-refinement-btn');
    const $document = $(document);
    const $body = $('body');

    $document.ready(() => {
        $refinementButtons.each(function () {
            initRefinementsState($(this));
        });
    });

    $document.on('modalOpened', () => {
        $('.card-header .js-custom-refinement-btn').each(function () {
            initRefinementsState($(this));
        });
    });

    $body.on('search:beforeFilter', (event, data) => {
        if (data && data.changedRefinementID) {
            saveRefinementState(data.changedRefinementID, data.isExpanded);
        }
    });

    $body.on('search:filter', () => {
        $('.js-custom-refinement-btn').each(function () {
            initRefinementsState($(this));
        });
    });

    $body.on('click', '.customRefinementBtn', function (e) {
        $(this, '.fa').toggleClass('pointArrow');
    });
};
